import onMaritimeAreaClick from './maritime-area-onClick';

namespace MaritimeAreaController {
  export const layerEvents = {
    onClick: onMaritimeAreaClick,
  };
}

export default MaritimeAreaController;
